import tw, { styled } from 'twin.macro';
import IFrame from 'react-onload-iframe';

export const StyledIframe = styled(IFrame)`
  ${tw`w-full mb-10`}
`;
